<template>
    <div>
        <div id="messageModal" class="modal" data-backdrop="static" data-keyboard="false">
            <div class="mecpopup-container">
                <div class="mecpopup-popup" role="dialog">
                <div class="mecpopup-olay"></div>
<!--                <button class="mecpopup-close" title="Close" @click="modalClose">-->
<!--                    <svg width="16" height="16" viewBox="0 0 16 16">-->
<!--                        <g stroke="#777" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round">-->
<!--                            <path d="M4 12L12 4M4 4l8 8"></path>-->
<!--                        </g>-->
<!--                    </svg>-->
<!--                </button>-->
                <div class="mecpopup-content-main">
                    <div class="mecpopup-content">
                        <div class="mecpopup-inner-content">
                            <div class="mecpopup-column">
                                <div class="mecpopup-blocks-wrapper">
                                    <div class="mecpopup-fields">
                                        <div class="mecpopup-block-image">
                                            <div class="mecpopup-fields-thumb">
                                        <span class="mecpopup-thumb-inner">
                                            <img src="/images/update-profile.png" class="mecpopup-thumbnail-image">
                                        </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mecpopup-fields">
                                        <div class="mecpopup-fields-inner">
                                            <div class="mecpopup-block-text">
                                                <div data-contents="true">
                                                    <div>
                                                <span style="font-weight: 700; font-size: 32px; font-family: Lato; color: rgb(0, 0, 0);">
                                                    <span data-text="true">Hey, wait!</span>
                                                </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mecpopup-fields">
                                        <div class="mecpopup-fields-inner">
                                            <div class="mecpopup-block-text">
                                                <div data-contents="true">
                                                    <div>
                                                        <span style="font-size: 16px; font-family: Lato; font-weight: 400; letter-spacing: normal; line-height: 180%; color: rgba(0, 0, 0, 0.52); background-color: transparent;">
                                                            <span data-text="true">You have successfully applied for the position! Update your profile to increase your chances of getting hired.</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mecpopup-fields">
                                        <div class="mecpopup-block-signup">
                                            <div class="mecpopup-actions">
                                                <form class="mecpopup-form">
                                                    <div class="mecpopup-action-field">
                                                        <a href="javascript:;" class="mecpopup-action-button" @click="goToEdit()">
                                                            Update Profile
                                                        </a>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mecpopup-fields">
                                        <div class="mecpopup-block-dismiss">
<!--                                            <button class="mecpopup-action-button-small" @click="modalClose()">-->
<!--                                                Thanks, I will do it later-->
<!--                                            </button>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data: '',
              }
        },
        methods: {
            modalClose() {
                $('#messageModal').modal('hide');
            },
            goToEdit(){
                $('#messageModal').modal('hide');
                this.$router.push('/dashboard/edit');
            },
        }
    }
</script>